import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=97366488"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=97366488&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97366488')) {
      api.createRecord('97366488', component.options)
    } else {
      api.reload('97366488', component.options)
    }
    module.hot.accept("./companyInformation.vue?vue&type=template&id=97366488", function () {
      api.rerender('97366488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/companyInformation.vue"
export default component.exports